import type { BrandShellConfig } from "../base/BrandShell";

import { HotelinkingLogo, HotelinkingMark } from "./HotelinkingLogo";
import { ADMIN_PROOFS } from "./proofs";

// Inline SVG turbulence noise; opacity/blend applied in CSS. `<`/`>` and the
// literal `%` are percent-encoded so the data URI stays valid.
const GRAIN =
  "url(\"data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")";

/**
 * Hotelinking Admin: a soft cream aurora and an oversized Hotelinking mark
 * whose arcs light up in turn, like a signal. The form follows the system
 * theme in the admin console's palette. No home link: it is an internal tool.
 */
export const ADMIN_SHELL: BrandShellConfig = {
  testId: "hl-shell",
  art: (
    <>
      <div className="hl-scene" aria-hidden="true">
        <span className="hl-aurora hl-aurora--a" />
        <span className="hl-aurora hl-aurora--b" />
        <HotelinkingMark className="hl-watermark" />
      </div>
      <div
        className="hl-grain"
        aria-hidden="true"
        style={{ backgroundImage: GRAIN }}
      />
    </>
  ),
  logo: (compact) => <HotelinkingLogo height={compact ? 28 : 36} />,
  eyebrow: "HOTELINKING",
  proofs: ADMIN_PROOFS,
};
